import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

import { useGifPlayback } from './GifPlaybackContext';
import commonMessages from './commonMessages';

const GifToggleButton = styled(Button)`
    min-height: 44px;
    min-width: 44px;

    &[hidden] {
        display: none;
    }

    &:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 2px;
    }
`;

const PlayAllAnimationsButton = ({
    intl, className, onClick, forceActive, isPlaying: isPlayingOverride, onPlay, onPause, style, isDrawerToggle
}) => {
    const {
        hasActiveGifs, isPlaying: contextIsPlaying, activeGifCount, playAll, pauseAll
    } = useGifPlayback();
    const isActive = forceActive !== undefined ? forceActive : hasActiveGifs;
    const isPlaying = isPlayingOverride !== undefined ? isPlayingOverride : contextIsPlaying;

    if (!isActive) return null;

    const handleClick = () => {
        if (isPlaying) {
            (onPause || pauseAll)();
        } else {
            (onPlay || playAll)();
        }
        if (onClick) onClick();
    };

    const pauseLabel = intl.formatMessage(commonMessages.pauseAnimationsButtonLabel);
    const previewLabel = intl.formatMessage(commonMessages.previewAnimationsButtonLabel);
    const label = isPlaying ? pauseLabel : previewLabel;
    
    const ariaLabel = activeGifCount > 0
        ? `${label} ${intl.formatMessage(commonMessages.animationsButtonDesignCount, { count: activeGifCount })}`
        : label;
    const toggleAttribute = isDrawerToggle ? { 'data-drawer-toggle': '' } : { 'data-group-toggle': '' };
    const Icon = isPlaying ? PauseCircleOutlineIcon : PlayCircleOutlineIcon;

    return (
        <div className='gif-toggle-button-wrapper' style={style}>
            <GifToggleButton
                type="button"
                variant="text"
                {...toggleAttribute}
                className={classNames(
                    'gif-toggle-button-inner', 'text-button', 'gif-play-pause-button', className
                )}
                aria-label={ariaLabel}
                onClick={handleClick}
            >
                <Icon aria-hidden="true" focusable="false" />
                {}
                <span className='gif-page-toggle-label' style={{ display: 'inline-grid' }}>
                    <span
                        style={{ gridArea: '1 / 1', visibility: isPlaying ? 'visible' : 'hidden' }}
                        aria-hidden="true"
                    >
                        {pauseLabel}
                    </span>
                    <span
                        style={{ gridArea: '1 / 1', visibility: isPlaying ? 'hidden' : 'visible' }}
                        aria-hidden="true"
                    >
                        {previewLabel}
                    </span>
                </span>
            </GifToggleButton>
        </div>
    );
};

PlayAllAnimationsButton.propTypes = {
    intl: intlShape.isRequired,
    className: PropTypes.string,
    
    
    onClick: PropTypes.func,
    
    forceActive: PropTypes.bool,
    isPlaying: PropTypes.bool,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    
    style: PropTypes.object,
    isDrawerToggle: PropTypes.bool
};

PlayAllAnimationsButton.defaultProps = {
    className: '',
    onClick: undefined,
    forceActive: undefined,
    isPlaying: undefined,
    onPlay: undefined,
    onPause: undefined,
    style: undefined,
    isDrawerToggle: false
};

export default injectIntl(PlayAllAnimationsButton);
